
export default function ARangeHero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden w-full">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="/images/336d158546b0.webp"
          alt="A Range Office Cabin"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 sm:pt-40 pb-16 sm:pb-20 lg:pb-24 text-center w-full">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 sm:gap-3 px-4 sm:px-6 py-2 sm:py-3 bg-gray-500/20 border border-gray-400/30 rounded-full mb-6 sm:mb-8">
          <div className="w-6 h-6 sm:w-8 sm:h-8 bg-gray-500/30 rounded-full flex items-center justify-center">
            <span className="text-base sm:text-lg font-bold text-gray-300">A</span>
          </div>
          <span className="text-gray-300 text-xs sm:text-sm uppercase tracking-widest">A SERIES</span>
        </div>

        {/* Main Title */}
        <h1 className="text-4xl sm:text-6xl lg:text-7xl xl:text-8xl font-thin mb-4 sm:mb-6 leading-tight px-4">
          Smart Modular <span className="text-gray-300">Office Spaces</span>
        </h1>

        {/* Subtitle */}
        <p className="text-base sm:text-lg lg:text-xl xl:text-2xl text-gray-300 max-w-4xl mx-auto mb-8 sm:mb-12 leading-relaxed px-4">
          Apple-cabin-style modular spaces designed for productivity, work, and commercial applications
        </p>

        {/* Key Features */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8 mb-8 sm:mb-12 w-full">
          {[
            { icon: 'ri-computer-line', label: 'Productivity-Focused' },
            { icon: 'ri-plug-line', label: 'Business-Ready' },
            { icon: 'ri-timer-flash-line', label: 'Rapid Deployment' },
            { icon: 'ri-shield-check-line', label: 'Professional Environment' }
          ].map((feature, index) => (
            <div key={index} className="bg-white/5 backdrop-blur-xl border border-gray-500/20 rounded-xl sm:rounded-2xl p-4 sm:p-6 hover:bg-white/10 hover:border-gray-400/40 transition-all w-full">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-500/20 rounded-lg sm:rounded-xl flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className={`${feature.icon} text-xl sm:text-2xl text-gray-300`}></i>
              </div>
              <p className="text-sm sm:text-base text-gray-300 font-medium">{feature.label}</p>
            </div>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row flex-wrap gap-4 justify-center px-4 w-full">
          <a 
            href="#models"
            className="w-full sm:w-auto px-6 sm:px-8 lg:px-10 py-3 sm:py-4 bg-gray-300 text-black text-sm sm:text-base font-medium rounded-full hover:bg-gray-200 transition-all hover:shadow-[0_0_30px_rgba(148,163,184,0.6)] whitespace-nowrap cursor-pointer text-center"
          >
            Explore Models
          </a>
          <a 
            href="/contact"
            className="w-full sm:w-auto px-6 sm:px-8 lg:px-10 py-3 sm:py-4 bg-transparent border border-gray-400/30 text-white text-sm sm:text-base font-medium rounded-full hover:border-gray-300/50 hover:shadow-[0_0_30px_rgba(148,163,184,0.2)] transition-all whitespace-nowrap cursor-pointer text-center"
          >
            Request Quote
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 sm:bottom-12 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl sm:text-3xl text-gray-400"></i>
      </div>
    </section>
  );
}
